import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    list: {
        admin: [],
        adminMoreAvailable: false,
        templates: [],
        toDo: [],
        toDoFromCycle: [],
        given: [],
        received: [],
        shared: [],
        singleUser: [],
        employeeIndex: [],
    },
    participantProgress: [],
    past: [],
};

const getters = {
    list(state) {
        return state.list;
    },
    templates(state) {
        return state.list?.templates ?? [];
    },
    templatesActive(state) {
        return (state.list?.templates ?? []).filter(template => template.type === "templateActive");
    },
    tasks(state) {
        return state.list?.toDo ?? [];
    },
    participantProgress(state) {
        return state.participantProgress ?? [];
    },
    past(state) {
        return state.past || [];
    },
};

const actions = {
    getList(
        { commit, state },
        {
            payload: {
                scope = "toDo",
                filter = "default",
                filterValue = "none",
                offset = 0,
                cache = false,
            },
        },
    ) {
        if (cache) {
            const data = getters.list(state);
            if (data && scope === "admin" && Array.isArray(data.admin) && data.admin.length) {
                return Promise.resolve();
            }
        }

        return api
            .get(
                `/api/reviewcycles/get/list/${scope}/${filter}/${encodeURIComponent(
                    filterValue,
                )}/${offset}`,
            )
            .then(res => {
                if (!res.data) {
                    return;
                }

                commit("updateList", { list: res.data });
            });
    },
    getParticipantProgress(
        { commit, state },
        { payload: { userFilter = {}, stateFilter = "all", offset = 0, reset = false } },
    ) {
        let employeeIndex = deepClone(state.list?.employeeIndex || []);
        let participantProgress = deepClone(state.participantProgress || []);

        if (reset) {
            employeeIndex = [];
            participantProgress = [];
        }

        return api
            .post(`/api/reviewcycles/participantprogress`, { userFilter, stateFilter, offset })
            .then(res => {
                const data = res.data;

                data.participantProgress.forEach(employee => {
                    if (employeeIndex.indexOf(employee.user._id) == -1) {
                        employeeIndex.push(employee.user._id);
                        participantProgress.push(employee);
                    }
                });

                commit("updateEmployeeIndex", { list: employeeIndex });
                commit("updateParticipantProgress", { participantProgress });
            });
    },
    getPast({ commit }, { payload: { userId } }) {
        return api.get(`/api/reviewcycles/get/list/past/${userId}`).then(res => {
            commit("updatePast", { list: res.data || [] });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        if (list.admin) {
            state.list.admin = list.admin;
        }
        if (list.adminMoreAvailable) {
            state.list.adminMoreAvailable = true;
        }
        if (list.templates) {
            state.list.templates = list.templates;
        }
        if (list.toDo) {
            state.list.toDo = list.toDo;
        }
        if (list.toDoFromCycle) {
            state.list.toDoFromCycle = list.toDoFromCycle;
        }
        if (list.given) {
            state.list.given = list.given;
        }
        if (list.shared) {
            state.list.shared = list.shared;
        }
        if (list.received) {
            state.list.received = list.received;
        }
        if (list.singleUser) {
            state.list.singleUser = list.singleUser;
        }
    },
    updateEmployeeIndex(state, { list }) {
        state.list.employeeIndex = list;
    },
    updateParticipantProgress(state, { participantProgress }) {
        state.participantProgress = [...participantProgress];
    },
    updatePast(state, { list }) {
        state.past = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
